const getElement = (selectors) => {
  return document.querySelector(selectors.join(','));
};

const getElements = (selectors) => {
  return document.querySelectorAll(selectors.join(','));
};

const getChildLinkEventText = (linkElement) => {
  const childLabel = linkElement.textContent;
  const parentLabel = linkElement.dataset.parentLabel;
  return `${parentLabel} > ${childLabel}`;
};

export default {
  getElement,
  getElements,
  getChildLinkEventText
};
